import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import styles from './AddRewardModal.css';
import NumberInputWithFeedback from '../../NumberInputWithFeedback';
import Select from '../../Select';

const ItemInput = ({
  items,
  itemVariants,
  itemIndex,
  rewardItem,
  itemOnChange,
  itemVariantOnChange,
  buildOptions,
  removeItem,
}) => (
  <div className={`well ${styles.well}`}>
    <div className="col-sm-11 bottom10 no-padding">
      <Select
        options={buildOptions(items)}
        disabled={_.isEmpty(items)}
        value={rewardItem.item_name}
        placeholder="Search Items"
        onChange={itemOnChange}
      />
    </div>
    <div className={`col-sm-1 bottom10 ${styles.remove}`}>
      <i
        className={`fa fa-times-circle fa-lg ${styles['x-button']}`}
        onClick={() => removeItem(itemIndex)}
      />
    </div>
    <div className="col-sm-11 bottom10 no-padding">
      <Select
        options={buildOptions(itemVariants[rewardItem.item_name])}
        value={rewardItem.item_variant_names}
        placeholder="Add Variants"
        onChange={itemVariantOnChange}
        closeOnSelect={false}
        multi
        allowSelectAll
        allOption={{
          label: 'All Variants (including new variants added in the future)',
          value: '*',
        }}
      />
    </div>
  </div>
);

const ItemInputList = ({
  items,
  itemVariants,
  rewardItems,
  itemOnChange,
  itemVariantOnChange,
  addItem,
  removeItem,
  buildOptions,
}) => (
  <div>
    {rewardItems.map((rewardItem, itemIndex) => (
      <ItemInput
        key={itemIndex}
        items={setItemOptions(items, rewardItems, rewardItem)}
        itemVariants={itemVariants}
        itemIndex={itemIndex}
        rewardItem={rewardItem}
        itemOnChange={selectedItem => itemOnChange(itemIndex, selectedItem)}
        itemVariantOnChange={selectedItemVariants =>
          itemVariantOnChange(itemIndex, selectedItemVariants)
        }
        buildOptions={buildOptions}
        removeItem={removeItem}
      />
    ))}
    <button
      type="submit"
      className={`btn btn-primary ${styles['btn-add-item']}`}
      onClick={addItem}
      disabled={
        items.length === rewardItems.length ||
        _.find(rewardItems, { item_name: null })
      }
    >
      Add More Items
    </button>
  </div>
);

const setItemOptions = (items, rewardItems, rewardItem) => {
  const diff = _.difference(items, rewardItems.map(x => x.item_name));
  return rewardItem.item_name ? diff.concat(rewardItem.item_name) : diff;
};

class PercentageDiscountItemInput extends Component {
  render() {
    const {
      rewardItems,
      rewardItemTypes,
      selectedRewardItemType,
      item: { items, categories, itemVariants },
    } = this.props;
    return (
      <div>
        <div className="row bottom5" style={{ paddingTop: '20px' }}>
          <div className="col-md-5">
            <div className={`${styles.title}`}>Redeem</div>
          </div>
          <div className="col-md-offset-2 col-md-5">
            <div className={`${styles.title}`}>Get Discount</div>
          </div>
        </div>
        <div className={`row ${styles['vertical-align']}`}>
          <div className="col-md-5">
            <NumberInputWithFeedback
              inputValue={this.props.point}
              onChangeValue={this.props.onChangePoint}
              suffix=" Points"
              placeholder="0 Points"
              thousandSeparator="."
              decimalPrecision={0}
              decimalSeparator=","
              errorMessage={this.props.pointInputError}
            />
          </div>
          <div className={`col-md-2 ${styles.center}`}>to</div>
          <div className="col-md-5">
            <NumberInputWithFeedback
              inputValue={this.props.discount}
              onChangeValue={this.props.onChangeDiscount}
              suffix="%"
              placeholder="1-100%"
              thousandSeparator="."
              decimalPrecision={0}
              decimalSeparator=","
              errorMessage={this.props.discountInputError}
            />
          </div>
        </div>
        <div className={`row ${styles['vertical-align']}`}>
          <div className="col-md-offset-7 col-md-5">
            <span className={styles['free-text']}>Set 100% for Free items</span>
          </div>
        </div>
        <div className="row bottom5" style={{ paddingTop: '20px' }}>
          <div className="col-md-12">
            <div className={`${styles.title}`}>For</div>
          </div>
          <div className="col-md-7">
            <div className={styles['single-radio']}>
              <label>
                <input
                  name="rewardItemType"
                  type="radio"
                  checked={selectedRewardItemType === rewardItemTypes.item}
                  value={rewardItemTypes.item}
                  onChange={() =>
                    this.props.onSelectRewardItemType(rewardItemTypes.item)
                  }
                />
                <span>Items</span>
              </label>
            </div>
          </div>
          <div className="col-md-5">
            <div className={styles['single-radio']}>
              <label>
                <input
                  name="rewardItemType"
                  type="radio"
                  checked={selectedRewardItemType === rewardItemTypes.category}
                  value={rewardItemTypes.category}
                  onChange={() =>
                    this.props.onSelectRewardItemType(rewardItemTypes.category)
                  }
                />
                <span>Any items from a Category</span>
              </label>
            </div>
          </div>
          <div className="col-md-12 top10 bottom10">
            {selectedRewardItemType === rewardItemTypes.item && (
              <ItemInputList
                items={items}
                itemVariants={itemVariants}
                rewardItems={rewardItems}
                itemOnChange={this.props.onSelectItem}
                itemVariantOnChange={this.props.onSelectItemVariant}
                addItem={this.props.addItem}
                removeItem={this.props.removeItem}
                buildOptions={this._buildOptions}
              />
            )}
            {selectedRewardItemType === rewardItemTypes.category && (
              <div>
                <Select
                  options={this._buildOptions(categories)}
                  disabled={_.isEmpty(categories)}
                  value={
                    (rewardItems &&
                      rewardItems.length > 0 &&
                      rewardItems[0].category_name) ||
                    ''
                  }
                  placeholder="Search Category"
                  onChange={this.props.onSelectCategory}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  _buildOptions = names => {
    if (_.isEmpty(names)) {
      return [];
    }
    return _.without(names, '').map(name => {
      return { value: name, label: name, disabled: false };
    });
  };
}

PercentageDiscountItemInput.propTypes = {
  point: PropTypes.string.isRequired,
  onChangePoint: PropTypes.func.isRequired,
  pointInputError: PropTypes.string.isRequired,
  discount: PropTypes.string.isRequired,
  onChangeDiscount: PropTypes.func.isRequired,
  discountInputError: PropTypes.string.isRequired,
  rewardItems: PropTypes.array.isRequired,
  rewardItemTypes: PropTypes.object.isRequired,
  selectedRewardItemType: PropTypes.string.isRequired,
  onSelectRewardItemType: PropTypes.func.isRequired,
  onSelectCategory: PropTypes.func.isRequired,
  onSelectItem: PropTypes.func.isRequired,
  onSelectItemVariant: PropTypes.func.isRequired,
  addItem: PropTypes.func.isRequired,
  removeItem: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  const { item } = state.customers;
  return { item };
}

export default connect(mapStateToProps)(PercentageDiscountItemInput);
